import React, {PureComponent} from "react"

import {TenantOnboardingStep} from "@irati/types"
import {FormattedMessage} from "@irati/utils/lang"

import StepLink from "./StepLink"
import {SectionTitle, SectionContent} from "./styled"
import stepDetails from "../../constants/stepConfig"

interface Props {
  steps: TenantOnboardingStep[],
  startingStepCount: number,
  title: string
}

class NavSection extends PureComponent<Props> {
  render() {
    const {title, steps, startingStepCount} = this.props

    if (steps.length === 0) return null

    // div used instead of fragment to allow flexbox: space-evenly
    return (
      <div>
        <SectionTitle bold>
          <FormattedMessage id={title} />
        </SectionTitle>
        <SectionContent>
          {steps.map((step: TenantOnboardingStep, index: number) => {
            return (
              <StepLink
                state={step.state}
                key={`${step.stepId}Step`}
                stepNumber={startingStepCount + index}
                {...stepDetails[step.stepId]} />
            )
          })}
        </SectionContent>
      </div>
    )
  }
}

export default NavSection
